import { Col, Row } from 'antd';
import { SIMULATE_LINE } from 'domain/entities/SimulateDescEntity';

type props = {
    lines: SIMULATE_LINE[];
};

const SimulateDescItem = ({ item }: any) => {
    return (
        <>
            <Col className="simulate-desc-left w-full h-auto" span={item.titleSpan}>
                <span className="simulate-desc-center__left">{item.title}</span>
            </Col>
            <Col
                className="w-full simulate-desc-center text-right h-auto"
                span={item.colSpan - item.titleSpan}
            >
                <span className="align-bottom">
                    <span className="simulate-desc-center__left align-bottom">{item.value}</span>
                    <span className="simulate-desc-center__left--sub h-auto align-text-bottom">
                        {item.prefix ?? ''}
                    </span>
                </span>
            </Col>
        </>
    );
};

const SimulateDesc = ({ lines }: props) => {
    return (
        <div className="simulate-desc">
            {lines.map((line: SIMULATE_LINE, index: number) => {
                return (
                    <Row
                        className="simulate-desc-line w-full h-auto"
                        key={index}
                        align={'middle'}
                        gutter={[12, 0]}
                    >
                        {line.items.map((item: any, i: number) => {
                            return <SimulateDescItem item={item} key={i} />;
                        })}
                    </Row>
                );
            })}
        </div>
    );
};

export default SimulateDesc;
